import { MemberSettingsApi } from '@deckee/api-app-main';
import apiConfiguration from '../../../backend/apiConfiguration';

export const api = new MemberSettingsApi(apiConfiguration);
